<template>
  <main>
    <dx-async :method="loadData">
      <dx-topbar v-if="!shouldHideTopbar"
      @logoutAction="logoutAndRedirect"
      :username="username"
      :isAdmin="isAdmin">
      </dx-topbar>
      <router-view></router-view>
    </dx-async>
  </main>
</template>

<script>
import { authService, userService } from '@services';

export default {
  name: 'App',
  data() {
    return {
      username: '',
      isAdmin: authService.getGroups().includes('ADMIN'),
    };
  },
  computed: {
    shouldHideTopbar() {
      return this.$route.meta.hideTopbar;
    },
  },
  methods: {
    async loadData() {
      if (authService.hasToken()) {
        this.refreshData();

        await userService.loadUserDetails();
        this.username = userService.getUserDetails().name;
      }
    },
    refreshData() {
    },
    logoutAndRedirect() {
      authService.logout();
      this.$router.push({ name: 'Logout' });
    },
  },
};

</script>
